import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import * as $ from 'jquery';
import './Datatable.css';

/* Table */
$.DataTable = require('datatables.net-bs4');

/* Export Table */
const pdfMake = require('pdfmake/build/pdfmake.js');
const pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;
window.JSZip = require('jszip');
require('datatables.net-buttons')();
require('datatables.net-buttons/js/buttons.flash.js')(); // Flash file export
require('datatables.net-buttons/js/buttons.colVis.js')(); // Column visibility
require('datatables.net-buttons/js/buttons.html5.js')(); // HTML 5 file export
require('datatables.net-buttons/js/buttons.print.js')(); // Print view button

class Datatable extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      datatable: {},
      currentPage: 0
    };
    this.audioEvents = this.audioEvents.bind(this);
  }

  audioEvents () {
    const formatTime = time => {
      const minTemp = Math.floor(time / 60);
      const secTemp = Math.floor(time % 60);
      const min = isNaN(minTemp) ? 0 : minTemp;
      const sec = isNaN(secTemp) ? 0 : secTemp;
      return (min < 10 ? '0' + min : min) + ':' + (sec < 10 ? '0' + sec : sec);
    };

    const btns = document.getElementsByClassName('audio-play-pause');
    for (const btn of btns) {
      const nameAudio = btn.getAttribute('audio');
      const audio = document.getElementById(nameAudio);
      const drt = document.getElementById('drt-' + nameAudio);
      const tm = document.getElementById('tm-' + nameAudio);
      const dwn = document.getElementById('dwn-' + nameAudio);
      const rng = document.getElementById('rng-' + nameAudio);

      dwn.onclick = () => {
        const file = dwn.id.split('-')[1];
        const url = dwn.getAttribute('url-audio');
        axios({
          url,
          method: 'GET',
          responseType: 'blob'
        }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', file);
          document.body.appendChild(link);
          link.click();
        });
      };

      rng.onchange = evt => {
        audio.currentTime = evt.target.value;
      };

      audio.onloadedmetadata = () => {
        rng.min = 0;
        rng.max = audio.duration;
        rng.setAttribute('mouse', 'up');
        rng.disabled = false;
      };

      rng.onmousedown = () => {
        rng.setAttribute('mouse', 'down');
      };

      rng.onmouseup = () => {
        rng.setAttribute('mouse', 'up');
      };

      audio.ontimeupdate = () => {
        drt.innerHTML = formatTime(audio.duration);
        tm.innerHTML = formatTime(audio.currentTime);
        if (rng.getAttribute('mouse') === 'up') {
          rng.value = audio.currentTime;
        }
        if (audio.ended) {
          btn.setAttribute('class', 'fa fa-play audio-play-pause');
        }
      };

      audio.onplay = () => {
        for (const btnPlayPause of btns) {
          const nameAudio = btnPlayPause.getAttribute('audio');
          const audio = document.getElementById(nameAudio);
          if (!audio.paused && nameAudio !== btn.getAttribute('audio')) {
            audio.pause();
          }
        }
        btn.setAttribute('class', 'fa fa-pause audio-play-pause');
      };

      audio.onpause = () => {
        btn.setAttribute('class', 'fa fa-play audio-play-pause');
      };

      btn.onclick = () => {
        const oldClasses = btn.getAttribute('class');
        if (oldClasses === 'fa fa-play audio-play-pause') {
          audio.play();
        } else {
          audio.pause();
        }
      };
    }
  }

  componentDidMount () {
    const {
      columns,
      buttons,
      order,
      dom,
      lengthChange,
      handleUpdateButton,
      handleDeleteButton,
      handleRestoreButton,
      handleLogoutButton,
      handleOptionsButton,
      handleChangeImageButton,
      handlePreviewButton,
      handleGenericButton,
      handleCloneButton
    } = this.props;

    const table = $(this.el).DataTable({
      data: [],
      columns: columns || [],
      dom:
        dom ||
        `<"row"
                <"col-sm-5"f><"col-sm-2"l><"col-sm-5"B>
            >
            <"table-responsive"rt>
            <"row"
                <"col-md-5 col-sm-12"i><"col-md-7 col-sm-12"p>
            >
            <"clear">`,
      lengthChange: typeof lengthChange === 'boolean' ? lengthChange : true,
      buttons: buttons || [],
      lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, 'Todos']],
      order: order || [[0, 'asc']],
      pagingType: 'full_numbers',
      autoWidth: false,
      headerCallback: nHead => {
        columns.forEach(function (column, position) {
          nHead.childNodes[position].title = column.tooltip || '';
        });
      },
      fnDrawCallback: () => {
        this.audioEvents();
      },
      language: {
        buttons: {
          excel: '',
          csv: '',
          pdf: '',
          print: '',
          copy: '',
          copySuccess: {
            1: 'Copiou 1 linha para a área de transferência',
            _: 'Copiou %d linhas para a área de transferência'
          },
          copyTitle: 'Tabela copiada'
        },
        info: 'Mostrando _START_ a _END_ de _TOTAL_ registros',
        infoEmpty: 'Mostrando 0 a 0 de 0 registros',
        paginate: {
          previous: '<',
          next: '>',
          first: '<<',
          last: '>>'
        },
        lengthMenu: '_MENU_',
        loadingRecords: 'Carregando dados...',
        search: '',
        searchPlaceholder: 'Pesquise nos registros...',
        infoFiltered: ' (filtrado de _MAX_ registros)',
        zeroRecords: 'Nenhum registro até este momento'
      }
    });

    this.setState({ datatable: table });

    $.fn.DataTable.ext.pager.numbers_length = 5;

    $(this.el).on('page.dt', () => {
      const { page } = table.page.info();
      if (page !== this.state.currentPage) {
        this.setState({ currentPage: page });
      }
    });

    $(this.el).on('length.dt', () => {
      const { page } = table.page.info();
      if (page !== this.state.currentPage) {
        this.setState({ currentPage: page });
      }
    });

    if (handleUpdateButton) {
      $(this.el).on('click', '.button-action-update', function () {
        const id = $(this).attr('id');
        handleUpdateButton(id);
      });
    }

    if (handleDeleteButton) {
      $(this.el).on('click', '.button-action-delete', function () {
        const tr = $(this)
          .parent()
          .parent();
        const dataRow = table.row(tr).data();
        handleDeleteButton(dataRow);
      });
    }

    if (handleRestoreButton) {
      $(this.el).on('click', '.button-action-restore', function () {
        const tr = $(this)
          .parent()
          .parent();
        const dataRow = table.row(tr).data();
        handleRestoreButton(dataRow);
      });
    }

    if (handleLogoutButton) {
      $(this.el).on('click', '.button-action-logout', function () {
        const tr = $(this)
          .parent()
          .parent();
        const dataRow = table.row(tr).data();
        handleLogoutButton(dataRow);
      });
    }

    if (handleOptionsButton) {
      $(this.el).on('click', '.button-action-options', function () {
        const tr = $(this)
          .parent()
          .parent();
        const dataRow = table.row(tr).data();
        handleOptionsButton(dataRow);
      });
    }

    if (handleChangeImageButton) {
      $(this.el).on('click', '.button-action-change-image', function () {
        const tr = $(this)
          .parent()
          .parent();
        const dataRow = table.row(tr).data();
        handleChangeImageButton(dataRow);
      });
    }

    if (handlePreviewButton) {
      $(this.el).on('click', '.button-action-preview', function () {
        const tr = $(this)
          .parent()
          .parent();
        const dataRow = table.row(tr).data();
        handlePreviewButton(dataRow);
      });
    }

    if (handleGenericButton) {
      $(this.el).on('click', '.button-action-generic', function () {
        const tr = $(this)
          .parent()
          .parent();
        const dataRow = table.row(tr).data();
        handleGenericButton(dataRow);
      });
    }

    if (handleCloneButton) {
      $(this.el).on('click', '.button-action-clone', function () {
        const tr = $(this)
          .parent()
          .parent();
        const dataRow = table.row(tr).data();
        handleCloneButton(dataRow);
      });
    }

    const entries = document.getElementsByClassName('dataTables_length');
    if (entries.length) {
      entries[0].firstElementChild.title = 'Quantidade de registros por página';
    }

    const copy = document.getElementsByClassName('dt-button buttons-copy');
    const excel = document.getElementsByClassName('dt-button buttons-excel');
    const csv = document.getElementsByClassName('dt-button buttons-csv');
    const pdf = document.getElementsByClassName('dt-button buttons-pdf');
    const print = document.getElementsByClassName('dt-button buttons-print');
    if (copy.length) {
      copy[0].title = 'Copiar tabela para área de transferência';
    }
    if (excel.length) {
      excel[0].title = 'Exportar para Excel';
    }
    if (csv.length) {
      csv[0].title = 'Exportar para CSV';
    }
    if (pdf.length) {
      pdf[0].title = 'Exportar para PDF';
    }
    if (print.length) {
      print[0].title = 'Print Tabela';
    }
  }

  componentWillUnmount () {
    if (this.state.datatable.destroy) {
      this.state.datatable.destroy();
    }
  }

  componentDidUpdate () {
    const { datatable, currentPage } = this.state;
    const { data } = this.props;
    datatable.clear();
    datatable.rows.add(data);
    datatable.draw();
    datatable.page(currentPage).draw('page');
  }

  render () {
    return (
      <div>
        <table
          id={Date.now().toString()}
          className="table table-striped table-bordered"
          ref={el => (this.el = el)}
        ></table>
      </div>
    );
  }
}

Datatable.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  buttons: PropTypes.array,
  order: PropTypes.array,
  dom: PropTypes.string,
  lengthChange: PropTypes.bool,
  handleUpdateButton: PropTypes.func,
  handleDeleteButton: PropTypes.func,
  handleRestoreButton: PropTypes.func,
  handleLogoutButton: PropTypes.func,
  handleOptionsButton: PropTypes.func,
  handleChangeImageButton: PropTypes.func,
  handlePreviewButton: PropTypes.func,
  handleGenericButton: PropTypes.func,
  handleCloneButton: PropTypes.func
};

export default Datatable;

export const RELOAD_TABLE_TIME = 1;
